import { post } from '@va/http-client';

export const generateImpersonate = (instance, data) => {
  const url = `/wix/impersonate/token`;

  return post(url, { instance: instance }, data);
};

export const refreshToken = (data) => {
  const url = `/wix/token-refresh`;

  return post(url, {}, data);
};

export const refreshImpersonateToken = (data) => {
  const url = `/wix/impersonate/token-refresh`;

  return post(url, {}, data);
};
